export const GX = {
  TexFormat: {
    I4: 0x0,
    I8: 0x1,
    IA4: 0x2,
    IA8: 0x3,
    RGB565: 0x4,
    RGB5A3: 0x5,
    RGBA8: 0x6,
    C4: 0x8,
    C8: 0x9,
    C14X2: 0x0a,
    CMPR: 0x0e,
  },
  Command: {
    NOOP: 0x00,
    DRAW_QUADS: 0x80,
    DRAW_QUAD_STRIP: 0x88,
    DRAW_TRIANGLES: 0x90,
    DRAW_TRIANGLE_STRIP: 0x98,
    DRAW_TRIANGLE_FAN: 0xa0,
    DRAW_LINES: 0xa8,
    DRAW_LINE_STRIP: 0xb0,
    DRAW_POINTS: 0xb8,
  },
  Attr: {
    PNMTXIDX: 0,
    TEX0MTXIDX: 1,
    TEX1MTXIDX: 2,
    TEX2MTXIDX: 3,
    TEX3MTXIDX: 4,
    TEX4MTXIDX: 5,
    TEX5MTXIDX: 6,
    TEX6MTXIDX: 7,
    TEX7MTXIDX: 8,
    POS: 9,
    NRM: 10,
    CLR0: 11,
    CLR1: 12,
    TEX0: 13,
    TEX1: 14,
    TEX2: 15,
    TEX3: 16,
    TEX4: 17,
    TEX5: 18,
    TEX6: 19,
    TEX7: 20,
    MAX: 20,
    _NBT: 25,
  },
  CompType: {
    U8: 0,
    S8: 1,
    U16: 2,
    S16: 3,
    F32: 4,
    RGBA8: 5,
  },
  CullMode: {
    NONE: 0,
    FRONT: 1,
    BACK: 2,
    ALL: 3,
  },
  BlendFactor: {
    ZERO: 0,
    ONE: 1,
    SRCCLR: 2,
    INVSRCCLR: 3,
    SRCALPHA: 4,
    INVSRCALPHA: 5,
    DSTALPHA: 6,
    INVDSTALPHA: 7,
  },
};

export const S16_SHIFT = 0x0d;
export const DEFAULT_TEX_MTX = [
  1, 0, 0, 0,
  0, 1, 0, 0,
  0, 0, 1, 0,
  0, 0, 0, 1,
];
